import script from "./CardAddTorneoCircuito.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardAddTorneoCircuito.vue?vue&type=script&setup=true&lang=ts"

import "./CardAddTorneoCircuito.vue?vue&type=style&index=0&id=01eaa2b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01eaa2b0"]])

export default __exports__